import { Row, Container } from 'react-bootstrap';
import Title from '../../components/blocks/title/meTicketTitle';
import StatisticsContainer from './StatisticsContainer';
import { useRef, useEffect } from 'react';
import { setPdfContentRef } from '../../hooks/usePdfDownload';
import { useSelector } from 'react-redux';

const MeTicketPage = () => {
  const contentRef = useRef(null);
  const plan = useSelector((state) => state.meTicketData.plan);

  useEffect(() => {
    setPdfContentRef(contentRef);
    return () => setPdfContentRef(null);
  }, []);

  return (
    <div className={'bg-white'} ref={contentRef}>
      <Container className="me-ticket ">
        <Row className="g-4 pb-5">
          <Title />
          <StatisticsContainer />
        </Row>
      </Container>
    </div>
  );
};

export default MeTicketPage;
